module.exports = __webpack_public_path__ + "fonts/gothica1-thin-webfont.6add97e.woff2";